import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18next from 'i18next';
import { useLocation, useHistory } from 'react-router-dom';
import useHandleLoader from '../../msreact-kit/hooks/useHandleLoader';
import Loader from '../../components/Shared/Utils/Loader';
import {
  Breadcrumb,
  NavigationButtons,
  DialogBox
} from '../../msreact-kit/packages/html-components';
import images from '../../assets/img';
import idConstants, { REGION } from '../../data/idConstants';
import {
  getProductDocsListById,
  publishProduct
} from '../../actions/api/hardwareAction';
import Card from '../multiple-tenant-selection-container/tenant-card';
import {
  getTenantCategory,
  getProductCategories
} from '../../actions/api/CategoryMappingAction';
import { getTenantList } from '../../actions/api/publishRequestAction';
import { getCatalogPublishableTenants } from '../../actions/product-service-action';
import { checkUserAgreementAcceptance } from '../../actions/LoginAction';
import Footer from '../../components/BaseLayout/footer';
import PublishMarketplace from '../multiple-tenant-selection-container/publish-sidebar';
import { getRegionCode } from '../../utils/get-region-details';
import { accessRoles, regionDetails } from '../../data/appConstants';
import { Dialog, Notification } from '@mobilitystore/components-interface';
import PricingCard from '../../components/pricing/pricing-card';
import { minPlanBenefitsToShow } from '../../shared/constants/field-constants';
import PricingPlanDialog from '../../components/pricing/pricing-plan-dialog';

import { getApiPlans } from '../../actions/api/pricing-plan-action';
import { REGION_CODE } from '../../actions/content-action';
import { getDeviceClass } from '../../utils';
import './index.scss';
import { awsEULADocumentLink, TENANT } from '../../actions/configuration';
import { toLowercaseReplaceSpace } from '../../shared/shared-function/helperFunctions';

export const renderEULALink = (linkText) => {
  return (
    <a href={awsEULADocumentLink} target='_blank' rel='noopener noreferrer'>
      {linkText}
    </a>
  );
};

const MultipleTenantSelection = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [handleLoader] = useHandleLoader();
  const basicInfo = location?.state?.basicInfo;
  const prodDetailedInfo = location?.state?.prodDetailedInfo;
  const catalogData = location?.state?.catalogData;
  const isCatalogPublish =
    catalogData &&
    Object.values(catalogData)?.every(
      (value) => value !== null && value !== undefined && value !== ''
    );
  const [checked, setChecked] = useState([]);
  const [imageData, setImageData] = useState([]);
  const [openSideBar, setOpenSideBar] = useState(false);
  const [selectedCardData, setSelectedCardData] = useState([]);
  const [pins, setPins] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState();
  const [awsPublishDialog, setAwsPublishDialog] = useState(false);
  const [selectedPricingCard, setSelectedPricingCard] = useState(null);
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [planPreviewData, setPlanPreviewData] = useState({});
  const [dialogShownFlag, setDialogShownFlag] = useState(false);
  const [showPricingNotification, setShowPricingNotification] = useState(false);
  const [selectedPricingData, setSelectedPricingData] = useState({});
  const [showPublishDialog, setShowPublishDialog] = useState(false);
  const [publishDialogContent, setPublishDialogContent] = useState({});
  const deviceClass = getDeviceClass();

  const {
    loader,
    tenantCategoryMapping,
    tenantList,
    tenantConfig,
    pricingPlans,
    user,
    content,
    userDetails
  } = useSelector((state) => {
    return {
      loader: state.LoaderReducer.loader,
      tenantList: state.PublishRequestReducer?.tenantList,
      tenantCategoryMapping: state.CategoryMappingReducer.tenantCategoryMapping,
      tenantConfig: state?.TenantConfigReducer?.tenantConfig,
      pricingPlans: state.ProductPricingPlanReducer?.pricingPlans,
      user: state?.loginReducer?.user,
      content: state?.ContentReducer?.content,
      userDetails: state?.loginReducer?.userDetails
    };
  });

  const isNARegion = REGION_CODE.toUpperCase() === REGION.NA.CODE;
  const resellerRole = user?.roles?.[0] === accessRoles.reseller;
  const dialogContent = content?.components?.aws_publish_dialog;
  const isAwsSelected = checked?.includes(TENANT.AWS);

  useEffect(() => {
    const enableRegionCode =
      getRegionCode() !== regionDetails[0]?.regionCode
        ? getRegionCode()
        : regionDetails[0]?.regionCode;

    isCatalogPublish &&
      dispatch(
        getCatalogPublishableTenants(
          catalogData?.catalogJobId,
          catalogData?.brand,
          catalogData?.providerDisplayName,
          enableRegionCode
        )
      );

    handleLoader();
    dispatch(checkUserAgreementAcceptance());
    dispatch(getTenantCategory());
    basicInfo?.productId &&
      dispatch(getTenantList(basicInfo?.productId, enableRegionCode));
    dispatch(getProductCategories());
    basicInfo?.productId && dispatch(getApiPlans(basicInfo?.productId));
    basicInfo?.productId &&
      dispatch(
        getProductDocsListById(
          basicInfo?.productId,
          idConstants.documentType.thumbnailImg
        )
      ).then((res) => {
        setImageData(res);
      });
  }, []);

  const enabledTenants = tenantList?.filter((tenants) => {
    return tenants.isEnabled === true;
  });

  const disabledTenants = tenantList?.filter((tenants) => {
    return tenants.isEnabled === false;
  });

  const handleClose = () => {
    history.goBack();
  };

  const handleSideBar = () => {
    setOpenSideBar(false);
  };

  const handleNext = () => {
    // Check if AWS is selected but no pricing card is selected
    if (isAwsSelected && !selectedPricingCard && isNARegion) {
      setShowPricingNotification(true);
      return;
    }

    // Hide notification if conditions are met
    setShowPricingNotification(false);
    handleCardData();

    // If only AWS is selected, publish directly without opening sidebar
    if (checked.length === 1 && isAwsSelected) {
      handleDirectAWSPublish();
      return;
    }

    setOpenSideBar(true);
  };
  useEffect(() => {
    if (isNARegion && resellerRole) {
      if (isAwsSelected && !dialogShownFlag) {
        // Show dialog whenever AWS is selected, unless user manually closed it
        setAwsPublishDialog(true);
        setDialogShownFlag(true);
      } else if (!isAwsSelected) {
        // Hide dialog and reset flag when AWS is not selected
        setAwsPublishDialog(false);
        setDialogShownFlag(false);
      }
    }
  }, [isAwsSelected, dialogShownFlag]);

  const handleCardData = () => {
    setSelectedCardData(
      checked.map((item) => tenantList?.find((card) => card.tenantId === item))
    );
  };

  const handleDialogClose = () => {
    setSelectedPricingCard(null);
    setAwsPublishDialog(false);
    setDialogShownFlag(true); // Set flag to prevent dialog from reopening immediately
  };

  const handleSave = () => {
    if (selectedPricingCard) {
      const selectedCard = pricingPlans?.find(
        (plan) => plan.planId === selectedPricingCard
      );
      setSelectedPricingData({
        planType: selectedCard?.planDetails?.planType,
        planId: selectedCard?.planId
      });
    }
    setAwsPublishDialog(false);
  };

  const handlePlanModal = (file = null) => {
    setShowPlanModal((prevState) => !prevState);
    setPlanPreviewData(file);
  };

  const handleDirectAWSPublish = () => {
    // Publish AWS product directly
    const productDataForPublish = {
      ...basicInfo,
      productCategoryId: basicInfo?.productCategoryId
    };

    dispatch(
      publishProduct(
        productDataForPublish,
        null,
        [TENANT.AWS],
        userDetails?.companyDetails?.companyId,
        selectedPricingData
      )
    ).then((response) => {
      if (response) {
        setPublishDialogContent({
          dialogTitle: 'DYNAMIC_FORM.SHARED.REQUEST_FOR_PUBLISH_SUBMITTED',
          dialogMessage:
            'DYNAMIC_FORM.SHARED.REQUEST_FOR_PUBLISH_SUBMITTED_TO_MARKETPLACE',
          dialogState: true
        });
      } else {
        setPublishDialogContent({
          dialogTitle: 'DYNAMIC_FORM.SHARED.REQUEST_FOR_PUBLISH_FAILED',
          dialogMessage:
            'DYNAMIC_FORM.SHARED.REQUEST_FOR_PUBLISH_FAILED_TO_MARKETPLACE',
          dialogState: false
        });
      }
      setShowPublishDialog(true);
    });
  };

  const handlePublishDialogClose = () => {
    setPublishDialogContent({});
    setShowPublishDialog(false);

    const productCategoryId = basicInfo?.productCategoryName;

    history.push({
      pathname: `/dashboard/my-products/${toLowercaseReplaceSpace(productCategoryId)}`
    });
  };

  const dialogButtons = [
    {
      label: 'Cancel',
      mode: 'secondary',
      onClick: handleDialogClose
    },
    {
      label: 'Save',
      mode: 'primary',
      onClick: handleSave,
      disabled: !selectedPricingCard
    }
  ];

  const pinnedCard = () => {
    const pinned = [];
    enabledTenants.forEach((card) => {
      if (pins[0]?.tenantId === card?.tenantId) {
        pinned.unshift(card);
      } else {
        pinned.push(card);
      }
    });
    return pinned;
  };

  const selectedBuyerPayload = {
    categoryId: String(basicInfo?.productCategoryId),
    userId: selectedBuyer,
    productList: [basicInfo.productId]
  };

  return (
    <React.Fragment>
      {loader && <Loader />}
      {awsPublishDialog && (
        <div className={`popup-container ${deviceClass}`}>
          <Dialog
            className='popup'
            show={awsPublishDialog}
            showCloseIcon={false}
            buttons={dialogButtons}
            onClose={handleDialogClose}
          >
            <h5 className='plan-type-title'>{dialogContent?.title}</h5>
            <div className='pricing-cards-container'>
              <h5>{dialogContent?.select_pricing_plan?.title}</h5>
              <Notification
                show={true}
                status={idConstants.notificationStatus.warning}
                message={
                  dialogContent?.select_pricing_plan?.notification_warning_info
                }
                showInfoIcon={true}
              />
              <div className='pricing-cards'>
                {pricingPlans?.map((data) => (
                  <div key={data?.planId} className='pricing-card-with-radio'>
                    <input
                      type='radio'
                      name={idConstants.pricingCard}
                      value={data?.planId}
                      checked={selectedPricingCard === data?.planId}
                      onChange={() => setSelectedPricingCard(data?.planId)}
                      id={`radio-${data?.planId}`}
                    />
                    <label htmlFor={`radio-${data?.planId}`}>
                      <PricingCard
                        cssName='publish-screen-pricing-card'
                        key={data?.planId}
                        id={data?.planId}
                        name={data.planName}
                        price={data.planCost}
                        isoCode={data.currency.currencyCode}
                        isView={true}
                        benefits={data?.planBenefits?.slice(
                          0,
                          minPlanBenefitsToShow
                        )}
                        handleChange={() => handlePlanModal(data)}
                        chargeableUnit={
                          data.rateLimit.chargeableUnit.chargeableUnitType
                        }
                        data={pricingPlans}
                        billingType={data?.billingType?.billingTypeCode}
                        pricingPlanCardData={data}
                        productStatusId={basicInfo?.status?.statusId}
                        isSelected={selectedPricingCard === data?.planId}
                      />
                    </label>
                  </div>
                ))}
              </div>
              <Notification
                show={true}
                status={idConstants.notificationStatus.neutral}
                message={
                  <>
                    {dialogContent.publish_eula_statement}{' '}
                    {renderEULALink(content?.constants?.end_user_license_agreement)}
                  </>
                }
                showInfoIcon={true}
              />
            </div>
          </Dialog>
        </div>
      )}
      {showPlanModal && (
        <div className={`aws-pricing-card-info-container ${deviceClass}`}>
          <PricingPlanDialog
            cssName='info-dialog'
            planPreviewData={planPreviewData}
            handleCancel={() => handlePlanModal()}
          />
        </div>
      )}
      {showPricingNotification && (
        <div className='pricing-card-error'>
          <Notification
            show={showPricingNotification}
            status={idConstants.notificationStatus.error}
            message={dialogContent?.pricing_card_selection_alert}
            onClose={() => setShowPricingNotification(false)}
          />
        </div>
      )}
      {showPublishDialog && (
        <DialogBox
          title={i18next.t(publishDialogContent?.dialogTitle)}
          subTitle={i18next.t(publishDialogContent?.dialogMessage)}
          isSuccess={publishDialogContent?.dialogState}
          isModal={true}
          isSecondaryBtn={false}
          handleConfirm={handlePublishDialogClose}
          primaryLabel={i18next.t('DYNAMIC_FORM.LABEL.OKAY')}
        />
      )}
      <div className='tenant'>
        <div className='tenant__breadcrumb'>
          <Breadcrumb
            items={[
              {
                title:
                  basicInfo?.productCategory?.categoryId ===
                  idConstants.automotiveSpares.categoryId
                    ? i18next.t('AUTOMOTIVE.AUTOMOTIVE_SPARES')
                    : basicInfo?.productCategoryName,
                from: '/dashboard/my-products/',
                to: '/'
              },
              {
                title: i18next.t('DYNAMIC_FORM.LABEL.ADD_PRODUCT')
              }
            ]}
            className='bread-crumb__container__arrow'
          />
        </div>
        <div className='tenant__container'>
          <div className='tenant__container__heading'>
            <img
              src={images.globeIcon}
              alt=''
              className='tenant__container__heading__img'
            />
            <div>
              <h2 className='tenant__container__heading__title'>
                {i18next.t('TENANT_SELECTION.PUBLISH_IN_MARKETPLACE')}
              </h2>
            </div>
          </div>
          <div>
            <h5 className='tenant__container__product'>
              {basicInfo?.productId
                ? i18next.t('ORDER_MANAGEMENT.PRODUCT_DETAIL.PRODUCT_DETAILS')
                : i18next.t('ORDER_MANAGEMENT.BULK_PRODUCT.CATALOG_DETAILS')}
            </h5>
          </div>
          <div className='tenant__container__detail'>
            <div className='tenant__container__detail__desc'>
              {imageData[0]?.blobFileUrl && (
                <div className='tenant__container__img-container'>
                  <img
                    src={imageData[0]?.blobFileUrl}
                    alt=''
                    className='tenant__container__img-container__img'
                  />
                </div>
              )}
              <div>
                <h6 className='tenant__container__detail__desc__name'>
                  {basicInfo?.productId
                    ? i18next.t('TENANT_SELECTION.PRODUCT_NAME')
                    : i18next.t('ORDER_MANAGEMENT.BULK_PRODUCT.CATALOG_NAME')}
                  :
                </h6>
                <p>
                  {!isCatalogPublish
                    ? prodDetailedInfo?.productName
                      ? prodDetailedInfo?.productName
                      : basicInfo.productName
                    : catalogData.catalogName}
                </p>
              </div>
              {prodDetailedInfo?.partNumber && (
                <div>
                  <h6 className='tenant__container__detail__desc__part'>
                    {i18next.t('DYNAMIC_FORM.PART_UPDATE.PART_NUMBER')} :
                  </h6>
                  <p>{prodDetailedInfo?.partNumber}</p>
                </div>
              )}
            </div>
          </div>
          <div>
            <h5 className='tenant__container__section'>
              {basicInfo?.productId
                ? i18next.t('TENANT_SELECTION.CHOOSE_THE_MARKETPLACE')
                : i18next.t('TENANT_SELECTION.CATALOG_TENANT_SELECTION')}
            </h5>
            {pinnedCard().length > 0 &&
              pinnedCard().map((list) => {
                return (
                  <Card
                    key={list.id}
                    list={list}
                    tenantCategoryMapping={tenantCategoryMapping}
                    checked={checked}
                    setChecked={setChecked}
                    enabledTenants={enabledTenants}
                    tenantId={list.tenantId}
                    pins={pins}
                    setPins={setPins}
                    setSelectedBuyer={setSelectedBuyer}
                  />
                );
              })}
          </div>
          {tenantConfig?.publishToTenant?.showDisabledTenants && (
            <div className='tenant__container__group-container'>
              <h5 className='tenant__container__group-container__group'>
                {basicInfo?.productId
                  ? i18next.t('TENANT_SELECTION.INTERESTED_TO_PUBLISH')
                  : i18next.t('TENANT_SELECTION.INTERESTED_TO_PUBLISH_CATALOG')}
              </h5>
              <p className='tenant__container__group-container__publish-interest'>
                {basicInfo?.productId
                  ? i18next.t('TENANT_SELECTION.EXPRESS_YOUR_INTEREST')
                  : i18next.t('TENANT_SELECTION.EXPRESS_YOUR_INTEREST_CATALOG')}
              </p>
              {disabledTenants.length > 0 &&
                disabledTenants.map((list) => {
                  return (
                    <Card
                      key={list.id}
                      list={list}
                      tenantCategoryMapping={tenantCategoryMapping}
                      basicInfo={basicInfo}
                      disabledTenants={disabledTenants}
                      pins={pins}
                      setPins={setPins}
                      setSelectedBuyer={setSelectedBuyer}
                      isCatalogPublish={isCatalogPublish}
                      catalogData={catalogData}
                    />
                  );
                })}
            </div>
          )}
          <NavigationButtons
            handleClose={handleClose}
            isShowPrevStepBtn={false}
            nextStepLabel={i18next.t('DYNAMIC_FORM.LABEL.SUBMIT')}
            handleNext={handleNext}
            nextStepDisabled={checked.length === 0}
          />
        </div>
        <div className='tenant__footer'>
          <Footer />
        </div>
        {openSideBar && (
          <PublishMarketplace
            productData={{
              ...basicInfo,
              productCategoryId:
                basicInfo?.productCategory?.categoryId ===
                idConstants.automotiveSpares.categoryId
                  ? basicInfo?.productCategory?.categoryId
                  : basicInfo?.productCategoryId
            }}
            handleSideBar={handleSideBar}
            tenantList={tenantList}
            checked={checked}
            selectedCardData={selectedCardData}
            basicInfo={basicInfo}
            selectedBuyerPayload={selectedBuyerPayload}
            selectedPricingData={selectedPricingData}
            isCatalogPublish={isCatalogPublish}
            catalogData={catalogData}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default MultipleTenantSelection;
